import * as _getSize2 from "get-size";

var _getSize = "default" in _getSize2 ? _getSize2.default : _getSize2;

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

// Flickity.Cell
(function (window, factory) {
  // universal module definition
  if (exports) {
    // CommonJS
    exports = factory(_getSize);
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Cell = factory(window.getSize);
  }
})(typeof window != "undefined" ? window : exports, function factory(getSize) {
  const cellClassName = "flickity-cell";

  function Cell(elem) {
    (this || _global).element = elem;

    (this || _global).element.classList.add(cellClassName);

    (this || _global).x = 0;
    this.unselect();
  }

  let proto = Cell.prototype;

  proto.destroy = function () {
    // reset style
    this.unselect();

    (this || _global).element.classList.remove(cellClassName);

    (this || _global).element.style.transform = "";

    (this || _global).element.removeAttribute("aria-hidden");
  };

  proto.getSize = function () {
    (this || _global).size = getSize((this || _global).element);
  };

  proto.select = function () {
    (this || _global).element.classList.add("is-selected");

    (this || _global).element.removeAttribute("aria-hidden");
  };

  proto.unselect = function () {
    (this || _global).element.classList.remove("is-selected");

    (this || _global).element.setAttribute("aria-hidden", "true");
  };

  proto.remove = function () {
    (this || _global).element.remove();
  };

  return Cell;
});

export default exports;